import { render, staticRenderFns } from "./LNumber.vue?vue&type=template&id=3b9d0f32&"
import script from "./LNumber.vue?vue&type=script&lang=js&"
export * from "./LNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports